import { render, staticRenderFns } from "./WorkGroupUpdate.vue?vue&type=template&id=d8deea5e&"
import script from "./WorkGroupUpdate.vue?vue&type=script&lang=js&"
export * from "./WorkGroupUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports